<template name="visitorList">
  <div class="visitor-list-view">
    <div class="visitor-list-content">
      <div
        class="visitor-content"
        :class="{'hide-visitor': !this.showVisitor, 'passed-invite': inviteStatus !== 1}">
        <div class="view-main" >
          <div class="visitor-list">
            <div class="view-header visiteInformation">
              <h4>{{$t('visitorInfo')}}</h4>
              <div v-on:click="toggleVisitor" class="btn-toggle">
                <span v-if="!this.showVisitor">{{$t('Expand')}}<i class="iconfont icon-down"></i>
                </span>
                <span v-else>{{$t('Collapse')}}<i class="iconfont icon-up"></i></span>
              </div>
            </div>
            <transition name="slide-fade" v-if="visitorDataList.length">
              <div class="view-content" v-show="this.showVisitor"  ref="visitorList">
                <div class="visitor-row" :key="index" v-for="(item, index) in visitorDataList" >
                  <span class="visitor-status" v-show="item.hasMaterial" v-if="item.visitorStatus == 1 || item.materialApproverStatus == 2 || item.materialApproverStatus == 3"
                    :class="item.materialApproverStatus == 3 ? 'status-grey' : 'status-red' ">
                    {{ item.materialApproverStatusDesc }}
                  </span>
                  <span class="visitor-status" v-show="item.hasMaterial" v-else
                    :class="item.visitorStatus == 5 ? 'status-grey' : 'status-red' ">
                    {{ item.visitorStatusDesc }}
                  </span>
                  <div class="name row">
                    <label class="checked" v-if="isSpecialVisitor">
                     <input type='checkbox' v-if="item.trackRemark" v-model='checkList'  name='checkboxinput' class='input-checkbox' :value=item.trackRemark>{{ item.visitorName }}
                    </label>
                    <label class="checked" v-else>
                     <input type='checkbox' v-show="isTicket && item.hasMaterial" v-model='checkList'  name='checkboxinput' class='input-checkbox' :value=item.visitorId @click="getVisitorStatus($event)" :data-value=item.visitorStatus >{{ item.visitorName }}
                    </label>
                  </div>
                  <div class="detail-info" v-if="item.isPriVisitor">
                    <div class="company-info" v-if="companyMaterial.length">
                      <h5 class="title" v-if="companyMaterial.length"><img src="../assets/images/qiye.png">{{$t('CompanyInfo')}}</h5>
                      <div class="info-content">
                        <dl class="row" v-show="item.isCompany" v-if="item.materialType==3 || item.materialType==4 || item.materialType==5" v-for="(item, index) in companyMaterial">
                          <dt class="col-5">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text">{{item.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialOne">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 info-text">{{one.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialTwo">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 spcial">
                            <dl  class="row" v-for="(one, idx) in one.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialEnght">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 info-text" :class="{'redColor': one.optionCode == 4}">
                            <span>{{one.answer}}</span></dd>
                        </dl>
                        <dl class="row" v-if="(item.isCompany && item.materialType==9) ||  (item.isCompany && item.materialType==7) || (item.isCompany && item.materialType==6)" v-for="(item, index) in companyMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookImgs"  v-if="item.materialType != 6">
                            <span  class="lookImgs" :data-value="item.answer">{{$t('ViewImage')}}</span>
                          </dd>
                          <dd class="col-7 info-text"  @click="lookAccessory" v-if="item.materialType == 6">
                            <span  class="lookImgs" :data-value="item.answer">{{$t('ViewAttachedFile')}}</span>
                          </dd>
                        </dl>
                       <!--  <dl class="row" v-if="(item.isCompany && item.materialType==6)" v-for="(item, index) in companyMaterial">
                          <dt class="col-5" :data-value="item.materialType" v-if="item.materialType == 6">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookAccessory">
                            <span  class="lookImgs" :data-value="item.answer">{{$t('ViewAttachedFile')}}</span>
                          </dd>
                        </dl> -->
                       <!--  <dl class="row" v-if="item.isCompany && (item.materialType==7)" v-for="(item, index) in companyMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookImgs">
                            <span  class="lookImgs" :data-value="item.answer">{{$t('ViewImage')}}</span>
                          </dd>
                        </dl> -->
                      </div>
                    </div>
                   <div class="personal-info" >
                      <h5 class="title"><img src="../assets/images/user.png"/>{{$t('visitorInfo')}}</h5>
                      <div class="info-content">
                        <dl class="row">
                          <dt class="col-5">{{$t('name')}}</dt>
                          <dd class="col-7  info-text">{{item.visitorName}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorPhoneNumber">
                          <dt class="col-5">{{$t('mobile')}}</dt>
                          <dd class="col-7 info-text">{{item.visitorPhoneNumber}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorEmail">
                          <dt class="col-5">{{$t('email')}}</dt>
                          <dd class="col-7 info-text">{{item.visitorEmail}}</dd>
                        </dl>
                      </div>
                      <div class="info-content">
                        <dl class="row" v-show="!item.isCompany" v-if="item.materialType==3 || item.materialType==4 || item.materialType==5"
                          v-for="(item, index) in perosonMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" :class="{'redColor': item.optionCode == 3}">
                            <span>{{item.answer}}</span>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialOne">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 info-text">{{one.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialTwo">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 spcial">
                            <dl  class="row" v-for="(one, idx) in one.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialEnght">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 info-text" :class="{'redColor': one.optionCode == 4 && one.status == 0}">
                            <span>{{one.answer}}</span></dd>
                        </dl>
                        <dl class="row" v-if="(!item.isCompany && item.materialType==9) || (!item.isCompany&& item.materialType==6) || (!item.isCompany && item.materialType==7)" v-for="(item, index) in perosonMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text"  @click="lookImgs" v-if="item.materialType != 6">
                            <span :data-value="item.answer" class="lookImgs">{{$t('ViewImage')}}</span>
                          </dd>
                          <dd class="col-7 info-text"  @click="lookAccessory" v-if="item.materialType == 6">
                            <span :data-value="item.answer" class="lookImgs">{{$t('ViewAttachedFile')}}</span>
                          </dd>
                        </dl>
                        <!-- <dl class="row" v-if="(!item.isCompany&& item.materialType==6)" v-for="(item, index) in perosonMaterial">
                          <dt class="col-5" :data-value="item.materialType" >{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookAccessory">
                            <span class="lookImgs" :data-value="item.answer">{{$t('ViewAttachedFile')}}</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="!item.isCompany&& (item.materialType==7)" v-for="(item, index) in perosonMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text"  @click="lookImgs">
                            <span :data-value="item.answer" class="lookImgs">{{$t('ViewImage')}}</span>
                          </dd>
                        </dl> -->
                      </div>
                    </div>
                    <div class="course-info" v-if="item.lessonList.length">
                      <h5 class="title"><img src="../assets/images/gongsijianjie.png"/>{{$t('course')}}<span>({{$t('learningProgress')}}: {{lessonOverdue[index]}}/{{item.lessonList.length}})</span></h5>
                      <div v-on:click="toggleVisitorTrain(index)" class="btn-toggle-train">
                        <span ref="downArrow">{{$t('Expand')}}<i class="iconfont icon-down"></i></span>
                        <span ref="upArrow" style="display: none;">{{$t('Collapse')}}<i class="iconfont icon-up"></i></span>
                      </div>
                      <div class="info-content" ref="child" style="display: none;">
                        <dl class="row" v-for="(item, index) in item.lessonList">
                          <dt class="col-9">{{item.lessonName}}</dt>
                          <dd class="col-3 status">{{item.lessonStatusDesc}}</dd>
                        </dl>
                      </div>
                    </div>
                    <div :class="item.lessonList.length ? 'hasborder notes': 'notes'" v-if="item.trackRemark && item.trackRemark.trackRemark">{{$t('Notes')}}: {{item.trackRemark.trackRemark}}</div>
                  </div>
                  <div class="detail-info" v-else>
                    <div class="personal-info">
                      <h5 class="title"><img src="../assets/images/user.png">{{$t('visitorInfo')}}</h5>
                      <div class="info-content">
                        <dl class="row">
                          <dt class="col-5">{{$t('name')}}</dt>
                          <dd class="col-7  info-text">{{item.visitorName}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorPhoneNumber">
                          <dt class="col-5">{{$t('mobile')}}</dt>
                          <dd class="col-7 info-text">{{item.visitorPhoneNumber}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorEmail">
                          <dt class="col-5">{{$t('email')}}</dt>
                          <dd class="col-7 info-text">{{item.visitorEmail}}</dd>
                        </dl>
                      </div>
                       <div class="info-content" v-if="newPerosonMaterial[index].isPersonMaterial.length">
                        <dl class="row" v-if="array.materialType==3 || array.materialType==4 || array.materialType==5" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-5">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" :class="{'redColor': array.optionCode == 3}"><span>{{array.answer}}</span></dd>
                        </dl>
                        <dl class="row"
                         v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialOne">
                          <dt class="col-5">{{array.topic}}</dt>
                          <dd class="col-7 info-text">
                            <span>{{array.answer}}</span>
                          </dd>
                        </dl>
                        <dl class="row"
                         v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialTwo">
                          <dt class="col-5">{{array.topic}}</dt>
                          <dd class="col-7 spcial">
                            <dl  class="row" v-for="(one, index) in array.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl class="row"  v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialEnght">
                          <dt class="col-5">{{array.topic}}</dt>
                          <dd class="col-7 info-text"  :class="{'redColor': array.optionCode == 4 && array.status == 0}">
                            <span>{{array.answer}}</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="array.materialType==9 || array.materialType==6 || array.materialType==7" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-5" :data-value="array.materialType">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookImgs" v-if="array.materialType != 6">
                            <span  class="lookImgs" :data-value="array.answer">{{$t('ViewImage')}}</span>
                          </dd>
                          <dd class="col-7 info-text"  @click="lookAccessory" v-if="array.materialType == 6">
                            <span class="lookImgs" :data-value="array.answer">{{$t('ViewAttachedFile')}}{{item.answer}}</span>
                          </dd>
                        </dl>
                       <!--  <dl class="row" v-if="array.materialType==6" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-5" :data-value="array.materialType">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text"  @click="lookAccessory">
                            <span class="lookImgs" :data-value="array.answer">{{$t('ViewAttachedFile')}}{{item.answer}}</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="array.materialType==7" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-5" :data-value="array.materialType">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookImgs">
                            <span  class="lookImgs" :data-value="array.answer">{{$t('ViewImage')}}</span>
                          </dd>
                        </dl> -->
                      </div>
                    </div>
                    <div class="course-info" v-if="item.lessonList.length">
                      <h5 class="title"><img src="../assets/images/gongsijianjie.png">{{$t('course')}}<span>({{$t('learningProgress')}}：{{lessonOverdue[index]}}/{{item.lessonList.length}})</span></h5>
                      <div v-on:click="toggleVisitorTrain(index)" class="btn-toggle-train">
                        <span ref="downArrow">
                          {{$t('Expand')}}<i class="iconfont icon-down"></i>
                        </span>
                        <span ref="upArrow" style="display: none;">{{$t('Collapse')}}<i class="iconfont icon-up"></i></span>
                      </div>
                      <div class="info-content" ref="child" style="display: none;">
                        <dl class="row" v-for="(item, index) in item.lessonList">
                          <dt class="col-9">{{item.lessonName}}</dt>
                          <dd class="col-3 lessonOverdueStatus">{{item.lessonStatusDesc}}</dd>
                        </dl>
                      </div>
                    </div>
                    <div class="notes" v-if="item.trackRemark && item.trackRemark.trackRemark">{{$t('Notes')}}: {{item.trackRemark.trackRemark}}</div>
                  </div>
                </div>
              </div>
            </transition>
            <div  v-if="this.visitorDataListNoData" v-show="this.showVisitor" class="visitor-empty">
              <h5>{{$t('NoVisitorInfo')}}</h5>
              <p>{{$t('reviewData')}}</p>
            </div>
          </div>
        </div>
        <div class="progress-list" v-if="progressData.length">
          <div class="view-header row">
            <h4 class="col-8">{{ $t('InvitationProgress') }}</h4>
            <div v-on:click="toggleProgress" class="col-4 btn-toggle-train" v-if="progressData.length > 5">
              <span v-show="!showProgress">{{ $t('More') }}<i class="iconfont icon-down"></i></span>
              <span v-show="showProgress">{{$t('hide')}}<i class="iconfont icon-up"></i></span>
            </div>
          </div>
          <div class="view-content">
            <ul>
              <li class="row" :class="showProgress == true ? 'isShow' : '' "" v-if="index<5" v-for="(item, index) in progressData">
                <div class="col-6">{{ item.createTime }}</div>
                <div class="col-6 message">{{ item.message }}</div>
              </li>
              <li class="row" v-show="showProgress" v-if="index>4" v-for="(item, index) in progressData">
                <div class="col-6">{{ item.createTime }}</div>
                <div class="col-6 message">{{ item.message }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="handle-bar fixed-bottom row" v-if="!isTicket && isCheckOwner && !confirmVisite && !isSpecialVisitor" v-show="this.showVisitor">
          <div class="col-6 refuse">
            <button class="btn btn-default" @click="showReasonAll">{{$t('reject')}}</button>
          </div>
          <div class="col-6 approve">
            <button class="btn btn-gradient" @click="approveAllList">{{$t('Agree')}}</button>
          </div>
        </div>
        <div class="handle-bar fixed-bottom row" v-if="isTicket && this.hasMaterial && !confirmVisite && !isSpecialVisitor" v-show="this.showVisitor">
          <label class="col-4 checkAll">
            <input type="checkbox" name="checkAll" v-model="checkboxAll" @change='changeState'>{{ $t('All') }}
          </label>
          <div class="col-4 refuse">
            <button class="btn btn-default" :disabled="this.isRefuseDisbaled" @click="showReasonOne"><span>{{$t('reject')}}</span></button>
          </div>
          <div class="col-4 approve">
            <button class="btn btn-gradient" :disabled="this.isApproveDisabled"  @click="approveAll">{{$t('Agree')}}(<span>{{checkList.length}}</span>)</button>
          </div>
        </div>
        <div class="handle-bar fixed-bottom row" v-if="this.confirmVisite && !isSpecialVisitor">
          <label class="col-4 checkAll">
            <input type="checkbox" name="checkAll" v-model="checkboxAll" @change='changeState'>{{ $t('All') }}
          </label>
          <div class="col-8 approve">
            <button class="btn btn-gradient" :disabled="this.isApproveDisabled"  @click="agreeToLeave">{{confirmVisiteTxt}}</button>
          </div>
        </div>
        <div class="handle-bar fixed-bottom row" v-if="isSpecialVisitor">
          <label class="col-4 checkAll">
            <input type="checkbox" name="checkAll" v-model="checkboxAll" @change='changeStateSV'>{{ $t('All') }}
          </label>
          <div class="col-8 approve">
            <button class="btn btn-gradient" :disabled="this.isAddNodesButton" @click="AddNotes">{{$t('AddNotes')}} <span v-if="this.addNotesTips">({{this.addNotesTips}})</span></button>
          </div>
        </div>
      </div>
      
    </div>
    <transition name="fade">
      <div class="visit-show" v-show="this.photoSwipeModal">
        <div>
          <photoSwipe ref="photoSwiper" @closePhoto="closePhoto"></photoSwipe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/javascript">
import { materialReview, checkPassOrReject, agreeToLeave } from '@/utils/api';
import photoSwipe from '@/components/photoSwipe.vue';

export default {
  name: 'visitorList',
  props: {
    inviteStatus: Number,
    progressData: Array,
    isTicket: Boolean,
    inviteId: String,
    isCheckOwner: Boolean,
    invitationStatus: Number,
    confirmVisite: Boolean,
    confirmVisiteTxt: String,
    securityGuardPostId: String,
    isSpecialVisitor: Boolean
  },
  components: {
    photoSwipe,
  },
  data() {
    return {
      visitorStatus: -1,
      visitorStatusList: [],
      showVisitor: true,
      checkedValue: [],
      items: [],
      approve: 2,
      refuse: 0,
      checkList: [],
      checkboxAll: false,
      isRefuseDisbaled: true,
      isApproveDisabled: true,
      thisModalTip: this.$t('selectOneVisitor'),
      showTrain: false,
      trainList: false,
      companyMaterial: [],
      perosonMaterial: [],
      newCompanyMaterial: [],
      newPerosonMaterial: [],
      lessonOverdue: [],
      showProgress: false,
      visitorDataList: [],
      photoSwipeModal: false,
      answerList: [],
      answerListPerson: [],
      answerListCompany: [],
      showVisitorList: false,
      OtherInvitorPerosonMaterial: [],
      visitorListData: false,
      divIndex: -1,
      hasMaterial: false,
      imgs: ['http://farm4.staticflickr.com/3920/15008465772_383e697089_m.jpg', 'http://farm4.staticflickr.com/3902/14985871946_86abb8c56f_m.jpg', 'http://farm7.staticflickr.com/6175/6176698785_7dee72237e_b.jpg'],
      noVisitor: false,
      lessonList: [],
      visitorDataListNoData: false,
      isAddNodesButton: true,
      addNotesTips: '',
    };
  },
  watch: {
    checkList: {
      handler() {
        if (this.checkList.length != 0) {
          this.isRefuseDisbaled = false;
          this.isApproveDisabled = false;
          this.isAddNodesButton = false;
        } else {
          this.isRefuseDisbaled = true;
          this.isApproveDisabled = true;
          this.isAddNodesButton = true;
        }
        if (this.checkList.length === this.visitorDataList.length) {
          this.checkboxAll = true;
        } else {
          this.checkboxAll = false;
        }
      },
      deep: true,
    },
  },
  computed: {

  },
  created() {

  },
  methods: {
    toggleVisitor() {
      this.showVisitor = !this.showVisitor;
      // this.$emit('ifSpread', true);
    },
    toggleVisitorTrain(index) {
      if (this.$refs.child[index].style.display == 'none') {
        this.$refs.child[index].style.display = 'block';
        this.$refs.downArrow[index].style.display = 'none';
        this.$refs.upArrow[index].style.display = 'block';
      } else {
        this.$refs.child[index].style.display = 'none';
        this.$refs.downArrow[index].style.display = 'block';
        this.$refs.upArrow[index].style.display = 'none';
      }
    },
    showReason() {
      this.$emit('popupStatus', true);
    },
    changeState() {
      this.checkList = [];
      this.visitorStatusList = [];
      if (this.checkboxAll) {
        this.visitorDataList.forEach((x) => {
          this.checkList.push(x.visitorId);
        });
        this.visitorStatusList = this.visitorDataList.map(x => ({
          status: x.visitorStatus,
          value: x.visitorId,
        }));
      }
    },
    changeStateSV() {
      this.checkList = [];
      if (this.checkboxAll) {
        this.visitorDataList.forEach(item => {
          if(item.trackRemark) {
            this.checkList.push(item.trackRemark);
          }
        });
      }
    },
    showReasonOne() {
      if (this.checkList.length === 1) {
        if (this.visitorStatusList.filter(x => x.value == this.checkList[0])[0].status == 1
            || this.visitorStatusList.filter(x => x.value == this.checkList[0])[0].status == 5) {
          this.$emit('popupStatus', true, this.checkList);
        } else {
          this.$emit('invitatisonStatusShow', true, this.$t('cannotRejected'));
        }
      } else {
        this.$emit('popupTip', true, this.thisModalTip);
      }
    },
    showReasonAll() {
      // console.log(this.invitationStatus);
      if (this.invitationStatus != 1 && this.invitationStatus != 11 && this.invitationStatus != 12 && this.invitationStatus != 13 && this.invitationStatus != 32) {
        this.$emit('invitatisonStatusShow', true, this.$t('CantBeRejected'));
      } else {
        this.$emit('popupGmModal', true);
      }
    },
    approveAll() {
      if (this.checkList.length) {
        // console.log(this.checkList);
        const getAgreeList = {
          invitationId: this.inviteId,
          idList: this.checkList,
          isPass: 1,
          reason: '',
        };
        this.$emit('isLoadingShow', true);
        materialReview(getAgreeList).then((res) => {
          // console.log(res);
          // console.log(res.data.content.message);
          if (res.data.content.status == 1) {
            this.$emit('isLoadingShow', false);
            window.location.reload();
          } else {
            this.$emit('isLoadingShow', false);
            this.$emit('approveAllModal', true, res.data.content.message);
          }
        });
      }
    },
    approveAllList() {
      if (this.inviteId) {
        const getAgreeList = {
          id: this.inviteId,
          isPass: true,
          reason: '',
        };
        this.$emit('isLoadingShow', true);
        checkPassOrReject(getAgreeList).then((res) => {
          if (res.data.content.status == 1) {
            this.$emit('isLoadingShow', false);
            window.location.reload();
          } else {
            this.$emit('isLoadingShow', false);
            this.$emit('approveAllListModal', true, res.data.content.message);
          }
        });
      }
    },
    toggleProgress() {
      this.showProgress = !this.showProgress;
    },
    getData(objData) {
      this.visitorDataList = objData;
      this.visitorDataList.length ? this.visitorDataListNoData = false : this.visitorDataListNoData = true;
      const hasMaterial = this.visitorDataList.map((item, index) => {
          if (item.hasMaterial) {
            return true;
          } 
            return false;
        });
      this.hasMaterial = hasMaterial.findIndex(x => x == true) != -1;
      const newArrayMaterial = this.visitorDataList.map((item, index) => {
        if (!item.isPriVisitor) {
          const newArray = item.materialOptionInfoList.filter((i) => {
              return i.isCompany == false;
            });
          const rObj = {};
          rObj.isPersonMaterial = newArray;
          return rObj;
        }
      });
        // console.log(newArrayMaterial);
      this.newPerosonMaterial = newArrayMaterial;
      if (this.newPerosonMaterial.length) {
        // console.log(this.newPerosonMaterial)
        const materialAnswerTemplate = this.newPerosonMaterial.map((array, index) => {
          if (array) {
            array.materialTwo = [];
            array.materialEnght = [];
            array.materialOne = [];
            const list = array.isPersonMaterial;
            const newList = list.map((item, index) => {
                if (item.materialType == 1) {
                  const newArrayList = JSON.parse(item.answer);
                  var materialTitleTemplate = item.materialTitleTemplate;
                  const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                  const newObj = {
                    'topic': materialTitleTemplate,
                    'answer': AnswerTemplate,
                  }
                  array.materialOne.push(newObj);  
                } else if (item.materialType == 2) {
                  const newArrayList = JSON.parse(item.answer);
                  var materialTitleTemplate = item.materialTitleTemplate;
                  const AnswerTemplate = JSON.parse(item.materialAnswerTemplate);
                  var newArrayTwo = [];
                  const answerIndex = newArrayList.map(function(view,index) {
                    newArrayTwo.push(AnswerTemplate[view]);
                  });
                  const newObj = {
                    'topic': materialTitleTemplate,
                    'answer': newArrayTwo,
                  }
                  array.materialTwo.push(newObj);
                } else if (item.materialType == 8) {
                  const newArrayList = JSON.parse(item.answer);
                  var materialTitleTemplate = item.materialTitleTemplate;
                  var optionCode = item.optionCode;
                  const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                  const status = newArrayList[0];
                  const newObj = {
                    'topic': materialTitleTemplate,
                    'answer': AnswerTemplate,
                    'optionCode': optionCode,
                    'status': status,

                  }
                  array.materialEnght.push(newObj);
                }
              });
          }
          return array;
        });
        this.OtherInvitorPerosonMaterial = materialAnswerTemplate;
      }

      const arrList = [];
      for (let i = 0; i < this.visitorDataList.length; i++) {
        const materialOptionInfoList = this.visitorDataList[i].materialOptionInfoList;
        const iscompany = [];
        const personList = [];
        const lessonList = this.visitorDataList[i].lessonList;
        this.lessonList = lessonList;
        if (this.visitorDataList[i].isPriVisitor) {
          iscompany = materialOptionInfoList.filter((i) => i.isCompany == true);
          personList = materialOptionInfoList.filter((i) => i.isCompany == false);
          this.companyMaterial = iscompany;
          this.perosonMaterial = personList;
        }
        // console.log('公司信息')
        // console.log(this.companyMaterial)
        // console.log('个人信息')
        // console.log(this.perosonMaterial)
        const lessonOverdue = [];
        for (let j = 0; j < this.lessonList.length; j++) {
          if (this.lessonList[j].lessonStatus == 2) {
            lessonOverdue.push(this.lessonList[j]);
          }
        }
        arrList.push(lessonOverdue.length);

        if (this.visitorDataList[i].trackRemark && this.visitorDataList[i].trackRemark.postName) {
           this.addNotesTips = this.visitorDataList[i].trackRemark.postName;
        }
      }
      this.lessonOverdue = arrList;
      this.selectOption(this.companyMaterial, 'company');
      this.selectOption(this.perosonMaterial, 'person');
    },
    selectOption(dataArray, status) {
      const rObj = {
        materialTwo: [],
        materialEnght: [],
        materialOne: [],
      };
        // console.log(dataArray);
      if (dataArray.length) {
        const answerIndex = [];
        const materialAnswerTemplate = dataArray.map((item, index) => {
          if (item) {
            if (item.materialType == 2) {
              const newArrayList = JSON.parse(item.answer);
              var materialTitleTemplate = item.materialTitleTemplate;
              var AnswerTemplate = JSON.parse(item.materialAnswerTemplate);
              let newObj = {};
              let newArrayTwo = [];
              const answerIndex = newArrayList.map((view,index) => {
                  newArrayTwo.push(AnswerTemplate[view])  
                });
              newObj = {
                topic: materialTitleTemplate,
                answer: newArrayTwo,
              };
              rObj.materialTwo.push(newObj);
            } else if (item.materialType == 8) {
              const newArrayList = JSON.parse(item.answer);
              var materialTitleTemplate = item.materialTitleTemplate;
              let optionCode = item.optionCode;
              const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
              const status = newArrayList[0];
              const newObj = {
                topic: materialTitleTemplate,
                answer: AnswerTemplate,
                optionCode: optionCode,
                status: status,
              };
              rObj.materialEnght.push(newObj);
            } else if (item.materialType == 1) {
              const newArrayList = JSON.parse(item.answer);
              var materialTitleTemplate = item.materialTitleTemplate;
              var AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
              const newObj = {
                topic: materialTitleTemplate,
                answer: AnswerTemplate,
              };
              rObj.materialOne.push(newObj);
            }
          }
        });
          // console.log(rObj);
        if (status == 'person') {
          this.answerListPerson = rObj;
        } else {
          this.answerListCompany = rObj;
        }
        // console.log( this.answerListPerson);
        // console.log( this.answerListCompany);
      }
    },
    lookImgs(e) {
      // console.log(e.target.dataset.value);
      const imgs = e.target.dataset.value;
      const imgArr = JSON.parse(imgs);
      if (imgArr) {
        this.photoSwipeModal = true;
        this.$refs.photoSwiper.loadPhoto(imgArr);
        this.$emit('showLookImgs', true);
      }
    },
    lookAccessory(e) {
      // console.log(e.target.dataset.value);
      const materials = e.target.dataset.value;
      const newArray = JSON.parse(materials);
      const newArraymaterialList = [];
      const newArraymaterialName = [];
      for (let j = 0; j < newArray.length; j++) {
        const current = newArray[j];
        const idx = current.lastIndexOf(',');
        const list = current.substring(0, idx);
        const name = current.substring(idx + 1, current.length);
        if (list != '') {
          newArraymaterialList.push(list);
          newArraymaterialName.push(name);
        }
      }
      // console.log(newArraymaterialList);
      // console.log(newArraymaterialName);
      if (newArraymaterialList.length) {
        this.photoSwipeModal = true;
        this.$refs.photoSwiper.loadMaterial(newArraymaterialList, newArraymaterialName);
        this.$emit('showLookImgs', true);
      }
    },
    closePhoto() {
      this.photoSwipeModal = false;
    },
    hideVisitor(visitor, approver, gm) {
      // console.log(visitor,approver,gm);
      this.visitorListData = !!visitor;
      // console.log(this.visitorListData);
      if (visitor || approver || gm) {
        this.showVisitorList = true;
      } else {
        this.showVisitorList = false;
      }
    },
    getVisitorStatus(e) {
      // console.log(e)
      // console.log(e.target._value);
      // console.log(e.target.dataset.value);
      const visitorList = {
        status: e.target.dataset.value,
        value: e.target._value,
      };
      // console.log(this.visitorStatusList);
      if (this.visitorStatusList.findIndex(x => x.value === visitorList.value) == -1) {
        this.visitorStatusList.push(visitorList);
      }
      // console.log(this.visitorStatusList);
    },
    agreeToLeave() {
      if (this.checkList.length) {
        // console.log(this.checkList);
        const getAgreeList = {
          invitationId: this.inviteId,
          securityGuardPostId: this.securityGuardPostId,
          visitorIdList: this.checkList,
        };
        this.$emit('isLoadingShow', true);
        agreeToLeave(getAgreeList).then((res) => {
          if (res.data.content.status == 1) {
            this.$emit('isLoadingShow', false);
            window.location.reload();
          } else {
            this.$emit('isLoadingShow', false);
            this.$emit('approveAllModal', true, res.data.content.message);
          }
        });
      }
    },
    AddNotes() {
      if (this.checkList.length) {
        const dataList = this.checkList;
        this.$emit('addNotesInfo', true,  dataList);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.notes {
  padding: 12px 0;
  border-top: 1px solid rgba(101, 101, 101, 0.15);
  font-size: 13px;
  color: #929292;
}
.visitor-content:not(.passed-invite) {
  padding-bottom: 50px;
}
.visitor-list-view {
}
.visitor-empty {
  text-align: center;
  margin: 20px 0;
  box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
  padding: 20px;
  border-radius: 4px;
  h5,
  p {
    font-size: 13px;
    padding-top: 10px;
    margin-bottom: 0;
  }
  h5 {
    font-weight: bold;
  }
  .btn-back {
    width: 125px;
    height: 42px;
    border-radius: 5px;
    font-size: 15px;
    line-height: 28px;
    color: #fff;
    margin-top: 5px;
    background-image: linear-gradient(69deg, #f36443, #e42029);
  }
}
.course-info {
  position: relative;
  .title {
    span {
      padding-left: 7px;
      font-size: 13px;
      font-weight: normal;
      color: #4a4a4a;
    }
    img {
      width: 12px !important;
    }
  }
  .btn-toggle-train {
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 0;
    span {
      font-size: 13px;
    }
    i {
      transform: scale(.75,.75);
      margin-left: 5px;
      font-size: 12px;
      display: inline-block;
      margin-right: -2px;
    }
  }
}
.reject-info {
  border-top: 1px solid rgba(101, 101, 101, 0.15);
  padding: 15px 0;
}
.view-header.visiteInformation {
  position: relative;
  margin-bottom: 0;
  h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .btn-toggle {
    position: absolute;
    top: 0;
    right: 0;
    span {
      font-size: 13px;
    }
    i {
      transform: scale(.75,.75);
      margin-left: 5px;
    }
  }
}
.visitor-list {
  width: 100%;
  padding: 0 20px;
  color: #4a4a4a;
  .view-content {
    margin-top: 20px;
  }
  .visitor-row {
    border-radius: 4px;
    background: #fff;
    font-size: 13px;
    box-shadow: 0 0 15px rgba(100,100,100,.1);
    position: relative;
    margin-bottom: 20px;
    line-height: 1;
    h5 {
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 15px;
      line-height: 1;
    }
    .visitor-status  {
      width: auto;
      height: 30px;
      display: block;
      color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 4px 0 8px;
      text-align: center;
      line-height: 30px;
      overflow: hidden;
      background-image: linear-gradient(69deg, #f36443, #e42029);
      padding: 0 14px;
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: -11px;
        left: -11px;
        width: 22px;
        height: 22px;
        border-radius: 11px;
        background: rgba(255,255,255,0.4);
      }
      &.status-grey {
        background-image: linear-gradient(69deg, rgba(146, 146, 146, 0.61), #9b9b9b);
      }
    }

    .visitor-status-text {
      position: absolute;
      right: 15px;
      top: 20px;
      color: red;
      font-size: 14px;
    }
    
    .name {
      margin-bottom: 15px;
      margin-left: 0;
      align-items: center;
      padding: 18px 20px;
      margin: 0;
      border-bottom: 1px solid rgba(101, 101, 101, 0.15);
      & > div:first-child {
        margin-right: 10px;
      }
      label {
        font-weight: bold;
      }
      input.input-checkbox[type='checkbox'] {
        width: 23px;
        height: 23px;
        appearance: none;
        background-color: #fff;
        outline: none;
        vertical-align: text-bottom;
        margin-bottom: -4px;
        margin-right: 7px;
        background: url(../assets/images/copy-21.png) no-repeat center;
      }
      input.input-checkbox[type='checkbox']:checked {
        background: url(../assets/images/11-copy.png) no-repeat center;
      }
      label {
        margin: 0;
      }
    }
    .detail-info {
      padding: 0 20px 15px;
      .company-info {
        padding-top: 15px;
        border-bottom: 1px solid rgba(101, 101, 101, 0.15);
        span {
          cursor: pointer;
        }
      }
      .personal-info {
        padding-top: 15px;
        border-bottom: 1px solid rgba(101, 101, 101, 0.15);
        span {
          cursor: pointer;
        }
      }
      .course-info {
        padding-top: 15px;
      }
    }
    dl {
      margin-bottom: 8px;
      dt {
        padding-right: 0;
        font-weight: normal;
        color: #929292;
        font-size: 13px;
        line-height: 18px;
      }
      .col-3 {
        color: #929292;
        font-size: 13px;
      }
      div {
        color: #929292;
      }
      dd {
        line-height: 18px;
        &.info-text {
          padding-left: 0;
          .lookImgs {
            text-decoration: underline;
            color: #e42029;
          }
        }
        &.col-3 {
          text-align: right;
          padding-left: 0;
          span {
            max-width: 52px;
          }
        }
      }
    }
    .approver-info {
      img {
        border-radius: 50%;
        width: 34px;
        height: 34px;
        border: 1px solid #eee;
        margin-right: 10px;
      }
      .status {
        width: 100%;
        height: 28px;
        border-radius: 14px;
        background-color: #f4f4f4;
        display: inline-block;
        line-height: 28px;
        font-size: 12px;
        text-align: center;
        color: #9b9b9b;
      }
      .status-red {
        color: #e42029;
      }
    }
    .info-content {
      span {
        & + span {
          padding-left: 10px;
        }
      }
      .status {
        text-align: right;
        color: #929292;
      }
      .lessonOverdueStatus {
        text-align: right;
        color: #929292;
      }
    }
  }
}
.visitor-content {
  .view-main {
    box-shadow: 0 15px 0px rgba(100, 100, 100, 0.1);
    padding: 20px 0;
  }
}
.visitor-content.hide-visitor {
  padding-bottom: 0;
  .view-main {
    border-radius: 10px;
    // padding-bottom: 5px;
    margin-bottom: 20px;
    box-shadow: 0 10px 25px rgba(100,100,100,.1);
  }
}
.progress-list {
  width: 100%;
  margin: 0 auto;
  padding: 10px 20px;
  color: #4a4a4a;
  margin-bottom: 70px;
  margin-top: 20px;
  .btn-toggle-train {
    cursor: pointer;
    text-align: right;
    font-size: 13px;
    padding-right: 25px;
    i {
      font-size: 12px;
      display: inline-block;
      transform: scale(0.75, 0.75);
      margin-left: 5px;
      margin-right: -5px;
    }
  }
  .view-header {
    h4 {
      font-size: 16px;
    }
  }
  .view-content {
    padding: 10px;
  }
  ul {
    padding: 0;
    list-style: none;
    position: relative;
    &:before {
      content: '';
      width: 2px;
      background: #cecece;
      display: block;
      position: absolute;
      top: 6px;
      left: 0;
      height: calc(100% - 12px);
    }
    .isShow:nth-of-type(5) {
      padding-bottom: 25px;
    }
  }
  li {
    padding-left: 24px;
    position: relative;
    font-size: 12px;
    line-height: 1;
    padding-bottom: 25px;
    &:nth-of-type(5) {
      padding-bottom: 0;
    }
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 10px;
      display: block;
      background: #999;
    }
    &:before {
      width: 12px;
      height: 12px;
      border-radius: 6px;
      opacity: 0.18;
    }
    &:after {
      width: 6px;
      height: 6px;
      border-radius: 3px;
      top: 3px;
      left: 13px;
      transform: scale(0.9,0.9);
    }
    &:first-child {
      color: #e42029;
      &:before,
      &:after {
        background: #ff2137;
      }
    }
    &:last-child {
      padding-bottom: 0;
    }
    .message {
      text-align: right;
      line-height: 18px;
    }
  }
}
.handle-bar {
  background: #fff;
  padding: 15px 20px;
  box-shadow: 0 0 15px rgba(100,100,100,.15);
  align-items: center;
  label.checkAll {
    font-size: 16px;
    color: #929292;
    margin: 0;
    input[type='checkbox'] {
      width: 23px;
      height: 23px;
      appearance: none;
      background-color: #fff;
      outline: none;
      background: url(../assets/images/copy-21.png) no-repeat center;
      vertical-align: text-bottom;
      margin-bottom: -1px;
      margin-right: 7px;
    }
    input[type='checkbox']:checked {
      border: none;
      background: url(../assets/images/zhengque.png) no-repeat center;
    }
  }
  .btn {
    width: 100%;
  }
  .refuse {
    cursor: pointer;
    padding-right: 10px;
    .btn {
      &:hover {
        color: #9b9b9b;
      }
    }
  }
  .approve {
    cursor: pointer;
    padding-left: .1em;
    padding-right: .1em;
  }
}
.show-popup {
  position: absolute;
}
.reason {
  display: none;
}
.visitor-row {
  .detail-info {
    .title {
      img {
        vertical-align: text-top;
        margin-right: 5px;
        width: 16px;
      }
    }
  }
}

.visit-show {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top:0;
  z-index: 1032;
  background:rgba(0, 0, 0, 0.4);
  .invisitListContent {
    position: absolute;
    bottom: 0;
  }
}

.visitor-list {
  .spcial {
    padding: 0;
    margin: 0;
    dl,
    dd {
      margin-bottom: 2px;
    }
  }
}

.redColor {
  span {
    color: #e42029;
  }
}

</style>
